import * as React from "react";
import { useState } from "react";
import { MainContainer, StyledWrapper } from "./styles";
import { ThemeProvider } from "@mui/material/styles";

import Header from "components/Header";
import theme from "theme/theme";
import { Sidebar } from "components/Sidebar";
import { Box } from "@mui/material";
import { useRealtimeSocket } from "hooks/useRealtimeSocket";
import { ChatUnreadProvider } from "context/ChatUnreadContext";
import { NotificationUnreadProvider } from "context/NotificationUnreadContext";
import { ChatUnreadSocketListener } from "components/Chat/ChatUnreadSocketListener";
import { NotificationUnreadSocketListener } from "components/Notification/NotificationUnreadSocketListener";

type ContainerProps = {
  children: React.ReactNode;
};

const Container: React.FC<ContainerProps> = ({ children }) => {
  const [menuIsOpen, setMenuIsOpen] = useState(false);
  const { connected: socketConnected } = useRealtimeSocket();

  const handleDrawerMenuOpen = () => {
    setMenuIsOpen(!menuIsOpen);
  };

  return (
    <ThemeProvider theme={theme}>
      <MainContainer>
        <ChatUnreadProvider socketConnected={socketConnected}>
          <NotificationUnreadProvider socketConnected={socketConnected}>
            <ChatUnreadSocketListener />
            <NotificationUnreadSocketListener />
            <Header
              isDrawerMenuOpen={menuIsOpen}
              handleDrawerMenuOpen={handleDrawerMenuOpen}
            />

            <Sidebar
              menuIsOpen={menuIsOpen}
              onClose={() => setMenuIsOpen(false)}
            />
            <StyledWrapper>
              <Box sx={{ padding: { xs: "8px 0 0 ", sm: "20px" } }}>
                {children}
              </Box>
            </StyledWrapper>
          </NotificationUnreadProvider>
        </ChatUnreadProvider>
      </MainContainer>
    </ThemeProvider>
  );
};

export default Container;
